import { useEffect } from "react";

export default function LimeConnectChat() {
  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.type = "text/javascript";
    script.src = "https://userlike-cdn-widgets.s3-eu-west-1.amazonaws.com/dad961a5a1a5492097f5c30984d7739aa0c9b5b482ed4be08378776c89c2cb71.js";
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return null;
}
